export default "__VITE_ASSET__D7QeOBf1__"